<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="p01">
<h1 class="part"><a id="page1"></a><a class="hlink" href="#/OEBPS/9780062032379_epub_toc_r1.htm#p01a"><span class="big2">PART ONE</span></a></h1>
<p class="nonindent01"> </p>
<h1 class="part01"><a class="hlink" href="#/OEBPS/9780062032379_epub_toc_r1.htm#p01a"><em>Prom</em></a></h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062032379_epub_p01_r1.vue?16fe80ec